import React, { useEffect, useState } from "react";
import api from "../../services/api";

const moisOptions = [
  { value: 1, label: "Janvier" }, { value: 2, label: "Février" },
  { value: 3, label: "Mars" }, { value: 4, label: "Avril" },
  { value: 5, label: "Mai" }, { value: 6, label: "Juin" },
  { value: 7, label: "Juillet" }, { value: 8, label: "Août" },
  { value: 9, label: "Septembre" }, { value: 10, label: "Octobre" },
  { value: 11, label: "Novembre" }, { value: 12, label: "Décembre" },
];

const RecapitulatifAdmin = () => {
  const now = new Date();
  const [mois, setMois] = useState(now.getMonth() + 1);
  const [annee, setAnnee] = useState(now.getFullYear());
  const [superviseurs, setSuperviseurs] = useState([]);
  const [dataParSup, setDataParSup] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [supSelectionne, setSupSelectionne] = useState(null);
  const [filtreCommercial, setFiltreCommercial] = useState("tous");

  const annees = [];
  for (let y = now.getFullYear(); y >= now.getFullYear() - 2; y--) annees.push(y);

  useEffect(() => {
    const fetchSuperviseurs = async () => {
      try {
        const res = await api.get("/commercials/dashboard/admin");
        const sups = res.data.performance_par_superviseur || [];
        setSuperviseurs(sups);
        if (sups.length > 0) {
          setLoading(true);
          const promises = sups.map(sup =>
            api.get(`/superviseurs/${sup.id}/recapitulatif/mensuel?mois=${mois}&annee=${annee}`)
              .then(r => ({ supId: sup.id, data: r.data }))
              .catch(() => ({ supId: sup.id, data: null }))
          );
          const results = await Promise.all(promises);
          const map = {};
          results.forEach(r => { map[r.supId] = r.data; });
          setDataParSup(map);
          setSupSelectionne(sups[0].id);
          setLoading(false);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchSuperviseurs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchRecap = async () => {
    if (superviseurs.length === 0) return;
    setLoading(true);
    setError("");
    setDataParSup({});
    setFiltreCommercial("tous");
    try {
      const promises = superviseurs.map(sup =>
        api.get(`/superviseurs/${sup.id}/recapitulatif/mensuel?mois=${mois}&annee=${annee}`)
          .then(r => ({ supId: sup.id, data: r.data }))
          .catch(() => ({ supId: sup.id, data: null }))
      );
      const results = await Promise.all(promises);
      const map = {};
      results.forEach(r => { map[r.supId] = r.data; });
      setDataParSup(map);
      if (superviseurs.length > 0) setSupSelectionne(superviseurs[0].id);
    } catch (err) {
      setError("Erreur lors du chargement");
    } finally {
      setLoading(false);
    }
  };

  const moisLabel = moisOptions.find(m => m.value === mois)?.label;
  const dataActive = supSelectionne ? dataParSup[supSelectionne] : null;
  const supActive  = superviseurs.find(s => s.id === supSelectionne);

  return (
    <>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "1.5rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Récapitulatif mensuel</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>Performance globale par superviseur</p>
        </div>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <select value={mois} onChange={e => setMois(Number(e.target.value))}
            style={{ padding: "0.5rem 0.75rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", background: "white" }}>
            {moisOptions.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
          <select value={annee} onChange={e => setAnnee(Number(e.target.value))}
            style={{ padding: "0.5rem 0.75rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", background: "white" }}>
            {annees.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button onClick={fetchRecap} disabled={loading}
            style={{ padding: "0.5rem 1.25rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "13px", borderRadius: "8px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "..." : "Afficher"}
          </button>
        </div>
      </div>

      {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}

      {loading ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "40vh" }}>
          <div style={{ width: "36px", height: "36px", border: "3px solid #f3e8ff", borderTop: "3px solid #7c3aed", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
        </div>
      ) : Object.keys(dataParSup).length > 0 && (
        <>
          {/* Sélecteur superviseur */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "1.25rem" }}>
            {superviseurs.map(sup => (
              <button key={sup.id} onClick={() => { setSupSelectionne(sup.id); setFiltreCommercial("tous"); }} style={{
                padding: "0.5rem 1rem", borderRadius: "9999px", fontSize: "12px",
                border: supSelectionne === sup.id ? "none" : "1px solid #e5e7eb",
                backgroundColor: supSelectionne === sup.id ? "#7c3aed" : "white",
                color: supSelectionne === sup.id ? "white" : "#6b7280",
                cursor: "pointer", fontWeight: supSelectionne === sup.id ? "500" : "400"
              }}>
                {sup.prenom} {sup.nom}
              </button>
            ))}
          </div>

          {dataActive ? (
            <>
              <div style={{ fontSize: "14px", color: "#6b7280", marginBottom: "1.25rem" }}>
                {supActive?.prenom} {supActive?.nom} — {moisLabel} {annee}
              </div>

              {/* Totaux */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))", gap: "12px", marginBottom: "1.25rem" }}>
                {[
                  { label: "Total clients", value: dataActive.totaux?.total_clients || 0 },
                  { label: "Nv. clients", value: dataActive.totaux?.total_nouveaux_clients || 0, color: "#185FA5" },
                  { label: "Total coupons", value: dataActive.totaux?.total_coupons_vendus || 0, color: "#7c3aed" },
                  { label: "Montant mobilisé", value: `${Number(dataActive.totaux?.total_montant_mobilise || 0).toLocaleString("fr-FR")} F`, color: "#ea580c" },
                  { label: "Montant encaissé", value: `${Number(dataActive.totaux?.total_montant_encaisse || 0).toLocaleString("fr-FR")} F`, color: "#0f6e56" },
                  { label: "Pénalités", value: `${Number(dataActive.totaux?.total_penalites_recuperees || 0).toLocaleString("fr-FR")} F`, color: "#dc2626" },
                ].map((stat, i) => (
                  <div key={i} style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "1rem" }}>
                    <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>{stat.label}</div>
                    <div style={{ fontSize: "18px", fontWeight: "500", color: stat.color || "#111827" }}>{stat.value}</div>
                  </div>
                ))}
              </div>

              {/* Tableau par commercial */}
              {dataActive.par_commercial?.length === 0 ? (
                <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "3rem", textAlign: "center" }}>
                  <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>📊</div>
                  <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucune donnée pour cette période</p>
                </div>
              ) : (
                <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden" }}>
                  <div style={{ padding: "1rem 1.25rem", borderBottom: "0.5px solid #e5e7eb" }}>
                    <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>Performance par commercial</div>
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f9fafb" }}>
                          {["Commercial", "Jours trav.", "Clients", "Nv. clients", "Coupons", "Mobilisé", "Encaissé", "Pénalités"].map(h => (
                            <th key={h} style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "11px", color: "#6b7280", fontWeight: "500", whiteSpace: "nowrap" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {dataActive.par_commercial?.map((com, i) => (
                          <tr key={i} style={{ borderTop: "0.5px solid #f3f4f6" }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f9fafb"}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
                            <td style={{ padding: "0.75rem 1rem" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <div style={{ width: "28px", height: "28px", borderRadius: "50%", backgroundColor: "#E6F1FB", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: "500", color: "#185FA5" }}>
                                  {com.nom?.charAt(0)}{com.prenom?.charAt(0)}
                                </div>
                                <span style={{ fontWeight: "500", color: "#111827" }}>{com.prenom} {com.nom}</span>
                              </div>
                            </td>
                            <td style={{ padding: "0.75rem 1rem" }}>{com.jours_travailles}</td>
                            <td style={{ padding: "0.75rem 1rem" }}>{com.total_clients}</td>
                            <td style={{ padding: "0.75rem 1rem" }}>
                              <span style={{ backgroundColor: "#E6F1FB", color: "#185FA5", padding: "2px 8px", borderRadius: "6px", fontWeight: "500" }}>{com.nb_nouveaux_clients || 0}</span>
                            </td>
                            <td style={{ padding: "0.75rem 1rem" }}>
                              <span style={{ backgroundColor: "#f3e8ff", color: "#7c3aed", padding: "2px 8px", borderRadius: "6px", fontWeight: "500" }}>{com.total_coupons_vendus}</span>
                            </td>
                            <td style={{ padding: "0.75rem 1rem", color: "#ea580c", whiteSpace: "nowrap" }}>{Number(com.total_montant_mobilise).toLocaleString("fr-FR")} F</td>
                            <td style={{ padding: "0.75rem 1rem", color: "#0f6e56", whiteSpace: "nowrap" }}>{Number(com.total_montant_encaisse).toLocaleString("fr-FR")} F</td>
                            <td style={{ padding: "0.75rem 1rem", color: Number(com.total_penalites_recuperees) > 0 ? "#dc2626" : "#9ca3af", whiteSpace: "nowrap" }}>
                              {Number(com.total_penalites_recuperees) > 0 ? `${Number(com.total_penalites_recuperees).toLocaleString("fr-FR")} F` : "—"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Section nouveaux clients */}
              {dataActive?.nouveaux_clients?.length > 0 && (
                <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden", marginTop: "1.25rem" }}>
                  <div style={{ padding: "1rem 1.25rem", borderBottom: "0.5px solid #e5e7eb", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "0.5rem" }}>
                    <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>
                      Nouveaux clients — {dataActive.nouveaux_clients.length} ce mois
                    </div>
                    <select value={filtreCommercial} onChange={e => setFiltreCommercial(e.target.value)}
                      style={{ padding: "0.4rem 0.75rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "12px", outline: "none", background: "white" }}>
                      <option value="tous">Tous les commerciaux</option>
                      {dataActive.par_commercial?.map(c => (
                        <option key={c.commercial_id} value={c.commercial_id}>{c.prenom} {c.nom}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f9fafb" }}>
                          {["Nom", "Téléphone", "Localisation", "Statut", "Date inscription", "Commercial"].map(h => (
                            <th key={h} style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "11px", color: "#6b7280", fontWeight: "500", whiteSpace: "nowrap" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {dataActive.nouveaux_clients
                          .filter(cl => filtreCommercial === "tous" || String(cl.commercial_id) === String(filtreCommercial))
                          .map((cl, i) => (
                            <tr key={i} style={{ borderTop: "0.5px solid #f3f4f6" }}
                              onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f9fafb"}
                              onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
                              <td style={{ padding: "0.75rem 1rem", fontWeight: "500", color: "#111827" }}>{cl.prenom} {cl.nom}</td>
                              <td style={{ padding: "0.75rem 1rem", color: "#6b7280" }}>{cl.telephone || "—"}</td>
                              <td style={{ padding: "0.75rem 1rem", color: "#6b7280" }}>{cl.localisation || "—"}</td>
                              <td style={{ padding: "0.75rem 1rem" }}>
                                <span style={{ fontSize: "11px", padding: "2px 8px", borderRadius: "6px",
                                  backgroundColor: cl.statut === "Fiable" ? "#f0fdf4" : cl.statut === "Tres fiable" ? "#E1F5EE" : cl.statut === "A risque" ? "#fff7ed" : "#fef2f2",
                                  color: cl.statut === "Fiable" ? "#16a34a" : cl.statut === "Tres fiable" ? "#0f6e56" : cl.statut === "A risque" ? "#ea580c" : "#dc2626"
                                }}>{cl.statut}</span>
                              </td>
                              <td style={{ padding: "0.75rem 1rem", color: "#6b7280", whiteSpace: "nowrap" }}>
                                {new Date(cl.date_inscription).toLocaleDateString("fr-FR")}
                              </td>
                              <td style={{ padding: "0.75rem 1rem", color: "#185FA5" }}>
                                {cl.commercial_prenom} {cl.commercial_nom}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "3rem", textAlign: "center" }}>
              <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucune donnée pour ce superviseur sur cette période</p>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default RecapitulatifAdmin;